import { Grid, makeStyles } from "@material-ui/core";
import React from "react";
import BackdropContainer from "./Backdrop";
import MediaCard from "./InsightCardV3";
import ConfifmModal from "../Favourites/ConfirmModal";
import { MAC_BROWSER_WIDTH } from "../util/utils";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  dynamicWidth: {
    margin: "0 auto",
    paddingTop: "1.5rem",
    maxWidth: 1700,
    width: "98%",
    [theme.breakpoints.down("lg")]: {
      maxWidth: window.self !== window.parent ? 1700 : 1200,
    },
    [theme.breakpoints.up("xl")]: {
      maxWidth: 1700,
      width: "99%",
    },
  },
  cardWrapper: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    columnGap: "1rem",
    rowGap: "1.5rem",
    maxWidth: "1200px",
    margin: "2rem auto 1rem",
    padding: "0 1rem",
  
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  },
}));

const NavItemMenuComponentNew = (props) => {
  const classes = useStyles();

  return (
    <Grid className={classes.root}>
      {props.location === "home" && (
        <div className={classes.cardWrapper}>
          {props.charts !== undefined &&
              props.charts
                .sort((a, b) => a.Sequence - b.Sequence)
                .map((it, index) => (
            <MediaCard
              key={it.dashboard_id}
              obj={it}
              setCharts={props.setCharts}
              curr_chart={it}
              charts={props.charts}
              favourites={{}}
              chartID={it.ChartID}
              header={it.Chart_Name}
              text={it.Description}
              image={`${props.baseURL}${it.URL_for_Thumbnail}`}
              changeLocation={props.handleLocationChange}
              dashboard_id={it.dashboard_id}
              addFavourite={props.addFavourite}
              removeFavourite={props.removeFavourite}
              Position={it.Position}
              navItem={it.Nav_Item}
              handleOpen={props.handleOpen}
              confirmSignal={props.confirmSignal}
              selectedDashboard={props.selectedDashboard}
              cleanAfterConfirm={props.cleanAfterConfirm}
            />
          ))}
        </div>
      )}

      <Grid
        container
        justifyContent="center"
        className={classes.dynamicWidth}
        style={
          navigator.platform.toLowerCase().includes("mac")
            ? {
                maxWidth:
                  Math.round((window.innerWidth * MAC_BROWSER_WIDTH) / 100) *
                  100,
              }
            : {}
        }
      >
        {props.routesComponent}
      </Grid>

      <ConfifmModal
        selectedDashboard={props.selectedDashboard}
        handleConfirmClose={props.handleConfirmClose}
        setConfirmSignal={props.setConfirmSignal}
        open={props.open}
        handleClose={props.handleClose}
        handleOpen={props.handleOpen}
      />
      <BackdropContainer showLoading={props.isFavActionLoading} />
    </Grid>
  );
};

export default NavItemMenuComponentNew;
